﻿(function() {
    "use strict";

    angular
        .module("app")
        .component("switch", {
            bindings: {
                id: "@",
                name: "@",
                type: "@",
                checked: "@",
                disabled: "@",
                rounded: "@",
                required: "@",
                value: "@",
                color: "@",
                ngModel: "=",
                ngValue: "@?",
                onChange: "&"
            },
            templateUrl: ['version', function(version) {
                return `/js/components/switch/switch.html?v=${version}`
            }],
            transclude: true,
            controller: SwitchController,
            controllerAs: "vm"
        });

    SwitchController.$inject = ["$scope", "$element", "$attrs", "$timeout"];

    function SwitchController($scope, $element, $attrs, $timeout) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.modelChanging = modelChanging;

        function onInit() {
            vm.id = vm.id || "switch_" + $scope.$id;
            vm.type = vm.type || "checkbox";
            vm.value = vm.value || "true";

            if ($attrs.rounded !== undefined) $(".switch", $element).addClass("rounded");

            if ($attrs.checked !== undefined && inputCtl) {
                inputCtl.attr("checked", "true");
            }
            if ($attrs.disabled !== undefined) {
                $($element).addClass("disabled");
            }
        }

        function onChanges(obj) {
            if (obj.id && obj.id.isFirstChange()) {
                $timeout(function() { $element.removeAttr("id").removeAttr("name"); });
            }
        }

        function modelChanging() {
            $timeout(function() { vm.onChange(); });
        }
    }
})();
